/**
 * Team - slider
 */
class Mokolove_Team {
    constructor () {
        if ($('.team').length) {
            let wrappers = $('.team');

            for (let i = 0; i < wrappers.length; i++) {
                this.init(wrappers.eq(i));
            }
        }
    }

    init (wrapper) {
        wrapper.find('.team-slider-text').text(wrapper.find('.member:first-child').attr('data-text'));
        wrapper.find('.prev').addClass('is-hidden');

        wrapper.find('.prev').on('click', (e) => {
            e.preventDefault();
            let current = parseInt(wrapper.find('.team-slider-inner').attr('data-current'), 10);
            let count = parseInt(wrapper.find('.team-slider-inner').attr('data-count'), 10);

            if (current > 1) {
                current--;
            }

            if (current === 1) {
                wrapper.find('.prev').addClass('is-hidden');
            }

            if (current < count) {
                wrapper.find('.next').removeClass('is-hidden');
            }

            wrapper.find('.team-slider-inner').attr('data-current', current);
            wrapper.find('.team-slider-text').text(wrapper.find('.member').eq(current - 1).attr('data-text'));
        });

        wrapper.find('.next').on('click', (e) => {
            e.preventDefault();
            let current = parseInt(wrapper.find('.team-slider-inner').attr('data-current'), 10);
            let count = parseInt(wrapper.find('.team-slider-inner').attr('data-count'), 10);

            if (current < count) {
                current++;
            }

            if (current === count) {
                wrapper.find('.next').addClass('is-hidden');
            }

            if (current > 1) {
                wrapper.find('.prev').removeClass('is-hidden');
            }

            wrapper.find('.team-slider-inner').attr('data-current', current);
            wrapper.find('.team-slider-text').text(wrapper.find('.member').eq(current - 1).attr('data-text'));
        });

        let swipeEffect = new Hammer(wrapper[0]);

        swipeEffect.on('swipe', ev => {
            if (ev.type === 'swipe' && ev.direction === 2) {
                wrapper.find('.next').trigger('click');
            }

            if (ev.type === 'swipe' && ev.direction === 4) {
                wrapper.find('.prev').trigger('click');
            }
        });
    }
}
